module.exports = __webpack_public_path__ + "img/customers_emt.bcc69388.png";